<template>
  <div class="heatmap_svg" :style="heatmapZoom"></div>
</template>

<script>
import h337 from 'heatmap.js'

export default {
  name: 'HeatmapSvg',
  props: [
    'svgData',
    'device',
    'eventType',
    'scale',
    'containerScale',
    'captureHeight'
  ],
  data () {
    return {
      isLoadedOnce: false
    }
  },
  computed: {
    isEventTypeClick () {
      return this.eventType === 'click'
    },
    heatmapZoom () {
      return {
        '--heatmap-ratio': this.getHeatmapRatio(),
        '--heatmap-percent': 100 / this.getHeatmapRatio() + '%'
      }
    }
  },
  watch: {
    scale (value) {
      this.clearHeatmap()
      this.loadHeatmap()
    }
  },
  mounted () {
    if (!this.isLoadedOnce) {
      this.loadHeatmap()
    }
  },
  destroyed () {
    this.clearHeatmap()
  },
  methods: {
    clearHeatmap () {
      const canvasEls = this.$el.getElementsByTagName('canvas')

      if (canvasEls.length) {
        canvasEls[0].parentNode.removeChild(canvasEls[0])
      }
    },
    getHeatmapRatio () {
      let ratio = 2
      let canvasRatio = 1600 / 700
      if (this.device === 'tablet') {
        ratio = 3
        canvasRatio = 1280 / 700
      } else if (this.device === 'phone') {
        ratio = 3
        canvasRatio = 375 / 438
      }
      if (this.captureHeight / canvasRatio > 16000) ratio = 5
      return ratio
    },
    loadHeatmap () {
      this.isLoadedOnce = true
      const radius = (this.device === 'desktop' ? 10 : 18) * this.containerScale / this.getHeatmapRatio()
      const maxOpacity = this.isEventTypeClick ? 0.3 : 0.2
      const minOpacity = this.isEventTypeClick ? 0.03 : 0.06
      const blur = this.isEventTypeClick ? 0.6 : 1
      let gradient

      if (this.isEventTypeClick) {
        gradient = {
          '0.2': 'blue',
          '0.35': 'cyan',
          '0.4': 'lime',
          '0.55': 'yellow',
          '0.63': 'orange',
          '0.9': 'red',
          '1': 'white'
        }
      } else {
        gradient = {
          '0.1': 'blue',
          '0.25': 'cyan',
          '0.3': 'lime',
          '0.55': 'yellow',
          '0.63': 'orange',
          '0.9': 'red',
          '1': 'white'
        }
      }

      const heatmap = h337.create({
        radius,
        maxOpacity,
        minOpacity,
        blur,
        gradient,
        container: this.$el
      })

      const svgData = this.normalizeRawData(this.svgData)
      const itemValues = svgData.map(h => h.value)
      itemValues.sort((a, b) => b - a)
      const maxValue = itemValues[Math.round(itemValues.length * 0.01)]

      heatmap.setData({
        max: maxValue,
        data: svgData
      })
    },
    normalizeRawData (data) {
      const rawData = []

      for (const xKey of Object.keys(data)) {
        for (const yKey of Object.keys(data[xKey])) {
          const value = data[xKey][yKey]
          const x = Math.round(xKey * this.scale) / this.getHeatmapRatio()
          const y = Math.round(yKey * this.scale) / this.getHeatmapRatio()

          if (x && y) {
            rawData.push({
              x,
              y,
              value
            })
          }
        }
      }
      return rawData
    }
  }
}
</script>

<style lang="scss">
.heatmap_svg {
  height: var(--heatmap-percent);
  width: var(--heatmap-percent);
  max-height: 16000px;
  transform: scale(var(--heatmap-ratio));
  transform-origin: 0 0;
  position: relative;
}
</style>
